import { Children, Fragment, isValidElement } from 'react';
import { Component } from "./Component.mjs";
export function invariant(condition, message) {
  if (!condition) throw new Error(message);
}

/**
 * Creates a component renderer config from a React "children" object,
 * which is usually either a `<Component>` element or an array of them.
 * Used internally by `<Selector>` to create a renderer config from its children.
 */
export function createComponentsRenderersFromChildren(children) {
  var renderers = [];
  Children.forEach(children, element => {
    if (! /*#__PURE__*/isValidElement(element)) {
      // Ignore non-elements. This allows people to more easily
      // inline conditionals in their renderer config.
      return;
    }
    if (element.type === Fragment) {
      // Transparently support React.Fragment and its children.
      renderers.push(...createComponentsRenderersFromChildren(element.props.children));
      return;
    }
    invariant(element.type === Component, "[".concat(typeof element.type === 'string' ? element.type : element.type.name, "] is not a <Component> component. All component children of <Selector> must be a <Component> or <React.Fragment>"));
    renderers.push(element.props);
  });
  return renderers;
}